import { AlgoliaStoreData } from '@jbhi-fi/apis/src/algolia/types/AlgoliaStoreData';
import algoliasearch from 'algoliasearch';
import { baseConfig, jbConfig } from '../../config/algolia';
import { AlgoliaLocationRequest, AlgoliaLocationResponse, AlgoliaStoresRequest } from './types';
import { parseAlgoliaLocationData, parseAlgoliaStoresData } from './utils';

const algoliaClient = algoliasearch(baseConfig.app_id, baseConfig.search_api_key);
const algoliaPostcodeIndex: any = algoliaClient ? algoliaClient.initIndex(jbConfig.algliaStorePostcodeIndex) : null;
const algoliaStoresIndex: any = algoliaClient ? algoliaClient.initIndex(jbConfig.algliaStoreLocatorIndex) : null;

export abstract class AlgoliaApiClient {
  static getLocations = async ({
    body,
    approximateLocation,
    aroundLatLngViaIP = false,
    hitsPerPage = 5,
    filters = 'hasCoordinates:true',
  }: AlgoliaLocationRequest): Promise<Array<AlgoliaLocationResponse>> => {
    const { hits } = await algoliaPostcodeIndex.search(body, {
      aroundLatLng: approximateLocation && `${approximateLocation.latitude}, ${approximateLocation.longitude}`,
      aroundLatLngViaIP,
      hitsPerPage,
      filters,
    });
    if (!hits.length) {
      throw { message: 'Could not find results' };
    }
    return parseAlgoliaLocationData(hits);
  };

  static getStores = async ({
    query,
    approximateLocation,
    aroundRadius = 200 * 1000,
    hitsPerPage = 5,
    filters = `displayOnWeb:${jbConfig.algoliaStoreShowOnWeb}`,
    returnEmpty,
  }: AlgoliaStoresRequest): Promise<Array<AlgoliaStoreData>> => {
    const { hits } = await algoliaStoresIndex.search(query, {
      aroundLatLng:
        approximateLocation &&
        approximateLocation.latitude &&
        approximateLocation.longitude &&
        `${approximateLocation.latitude}, ${approximateLocation.longitude}`,
      aroundRadius,
      hitsPerPage,
      filters,
      returnEmpty,
    });
    return parseAlgoliaStoresData(hits, approximateLocation);
  };

  static getStore = async (storeId: string): Promise<AlgoliaStoreData> => {
    const storeData = await algoliaStoresIndex.getObject(storeId);

    return parseAlgoliaStoresData([storeData])[0];
  };
}
